<h1 mat-dialog-title>Advance the invoice number?</h1>

<div mat-dialog-content class="advance-invoice-number-dialog">
  <p class="advance-message">
    This gives the invoice a new Corona invoice number and a new reference number.
    Documents already generated carry the old number: regenerate and re-send them afterwards.
    An invoice that has been sent to accounting cannot be advanced.
  </p>

  <div class="details-container">
    <span class="detail-label">Current number:</span>
    <span class="detail-value">{{ data.currentNumber }}</span>
    <span class="detail-label">Next number:</span>
    <span class="detail-value">{{ data.nextNumber }}</span>
  </div>

  <mat-form-field class="full-width">
    <mat-label>Reason</mat-label>
    <textarea
      matInput
      rows="3"
      class="reason-input"
      placeholder="Why is this invoice being renumbered?"
      [formControl]="reasonControl"
    ></textarea>
    <mat-hint>Recorded as a priority comment on the invoice, authored by you.</mat-hint>
  </mat-form-field>
</div>

<div mat-dialog-actions align="center">
  <button mat-button type="button" class="cancel-button" (click)="onCancel()">Cancel</button>
  <button
    mat-button
    type="button"
    class="confirm-button"
    [disabled]="!reason"
    (click)="onConfirm()"
  >
    Advance number
  </button>
</div>
